import { LineChart, Line, ResponsiveContainer, XAxis, Tooltip, CartesianGrid } from "recharts";

const CHART_MARGIN = { top: 8, right: 12, left: -16, bottom: 0 };
const TICK_STYLE = { fontSize: 12 };
const TOOLTIP_STYLE = { borderRadius: 12, border: "1px solid #E0E4E2", fontSize: 12 };
const DOT_STYLE = { r: 4, fill: "#E85D04" };

export default function DashboardChart({ data }) {
  return (
    <div className="card-soft p-6">
      <div className="flex items-center justify-between">
        <span className="label-cap">Leads · last 7 days</span>
      </div>
      <div className="mt-4 h-[180px]">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={data || []} margin={CHART_MARGIN}>
            <CartesianGrid strokeDasharray="3 3" stroke="#E0E4E2" vertical={false} />
            <XAxis dataKey="date" stroke="#5C6B68" tick={TICK_STYLE} />
            <Tooltip contentStyle={TOOLTIP_STYLE} />
            <Line type="monotone" dataKey="count" stroke="#E85D04" strokeWidth={3} dot={DOT_STYLE} />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
